/*
 * @Author: PanYunhong
 * @Date: 2022-03-29 11:16:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-17 14:46:49
 * @LastEditors: PanYunhong
 * @LastEditTime: 2022-04-11 16:34:36
 * @description: 配置文档 https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \air2.0-frontend\src\utils\AMap\index.ts
 */
import qs from 'qs';

import UrlPictureLayer from './urlPictureLayer/index';
import WMSPictureLayer from './wmsLayer/index';
import Marker from './marker/index';

/**
 * @param {string} domId 容器id
 * @param {number[]} center 中心点
 * @param {number} zoom 等级
 * @param {string} style 底图风格
 */

export default class VueAMap extends AMap.Map {
  pictureLayer: any;

  tempPictureLayer:any;

  urlPictureLayer: any;

  tempUrlPictureLayer: any;

  wmsLayer: any;

  tempWmsLayer:any;

  markers:any;

  constructor (domId: string, center:number[],zoom:number,style = 'darkblue') {
    super(domId,{
      key: 'd79ff396531b948ce14d5be1c733fc36',
      center,
      zoom,
      zooms: [4,20,],
      mapStyle: `amap://styles/${style}`,

      /*
       * layers: [new AMap.TileLayer({
       *   // 基础底图不使用掩膜
       *   rejectMapMask: true,
       * }),],
       */
      // 要用掩膜就必须得用3d模式
      viewMode: '2D',
      resizeEnable: true,
    });
    this.pictureLayer = {};
    this.urlPictureLayer = {};
    this.tempPictureLayer = {};
    this.wmsLayer = {};
    this.tempWmsLayer = {};
    // 环境站点图层
    this.enviromentStationLayer = [];
    this.markers = [];
    this.tempUrlPictureLayer = {};
  }

  /**
   * 设置掩膜
   * @param {string} region 区域
   * @returns {void}
   */
  setRegion = (region = '中国'): void => {
    const opts = {
      // 返回下一级行政区
      subdistrict: 0,
      // 返回行政区边界坐标组等具体信息
      extensions: 'all',
    };
    // const district = new AMap.DistrictSearch(opts);

    this.add(new AMap.TileLayer({
      // 基础底图不使用掩膜
      rejectMapMask: true,
    }));

    this.setMapStyle(`amap://styles/darkblue`);

    this.layers = [new AMap.TileLayer({
      // 基础底图不使用掩膜
      rejectMapMask: true,
    }),];

    AMap.plugin('AMap.DistrictSearch', () => {
      const district = new AMap.DistrictSearch(opts);

      district.search(region, (status: any, result: any) => {
        const bounds = result.districtList[0].boundaries;
        const mask = [];

        for (let i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i],]);
        }

        this.setMask(mask);
      });
    });
  }

  /**
   *添加TMS切片图层
   * @param {*} url 图片路径
   * @return {void}
   */
  addUrlPicRange = (url:string) : any => {
    const temp = new UrlPictureLayer(url, (flag:boolean) => {
      if (flag) {
        this.remove(this.urlPictureLayer);
        this.urlPictureLayer = temp;
        this.tempUrlPictureLayer = temp;
      }
    });

    this.add(temp);

    return this.urlPictureLayer;
  }

  /**
   *添加tif图层
   * @param {*} url 图片路径
   * @return {void}
   */
  /*
   * addWmsLayer = (url:string) : any => {
   *   const temp = new WMSPictureLayer(url, (flag:boolean) => {
   *     if (flag) {
   *       this.remove(this.tempWmsLayer);
   *       this.wmsLayer = temp;
   *       this.tempWmsLayer = temp;
   *     }
   *   });
   */

  //   this.add(temp);

  /*
   *   return this.wmsLayer;
   * }
   */

  /**
   * 视角定位置范围
   * @param {any} extent [[x, y], [x, y]] 对角坐标
   * @param {any} padding [x,y] 平移像素值
   * @return {void}
   */
  setExtent = ([[southWestLng,southWestLat,],[northEastLng,northEastLat,],]: Array<any>, [panX,panY,]: Array<number>):void => {
    const mybounds = new AMap.Bounds([southWestLng, southWestLat,], [northEastLng,northEastLat,]);

    this.setBounds(mybounds);
    this.panBy(panX,panY);
  }

  /**
   * 绘制环境站点
   * @param {any[]} data 传入单点数据
   * @param {any} clickCallback 点击回调
   * @return {void}
   */
  markEnvironments = (data: any[], clickCallback: any): any => {
    if (Object.keys(this.enviromentStationLayer).length) {
      this.removeMarkEnvironments();
    }
    data.forEach((item: any) => {
      if (!item.lat || !item.lon) return;
      const marker = new Marker(this,item);

      this.enviromentStationLayer.push(marker);
      marker.on('click',(e: any) => {
        const params = qs.stringify({
          pointGid: item.pointGid,
          time: item.reportTime,
        });

        clickCallback(e,params);
      });
    });
  }

  removeMarkEnvironments = (): void => {
    this.remove(this.enviromentStationLayer);
    this.enviromentStationLayer.forEach((item: any) => {
      item.hide();
    });
    this.enviromentStationLayer = [];
  }

  /**
   * 添加图片
   * @param {string} url 图片路径
   * @param {*} extent 图片四至
   * @returns {void}
   */
  addPicture = (url: string, extent = [[72, 17,], [136, 55,],]): any => {
    if (Object.keys(this.pictureLayer).length) {
      this.removePicture();
    }

    this.pictureLayer = new AMap.ImageLayer({
      url,
      bounds: new AMap.Bounds(
        extent[0],
        extent[1]
      ),
      opacity: 0.7,
      zoom: 5,
    });

    this.add(this.pictureLayer);

    return this.pictureLayer;
  }

  /**
   *移除产品图片
   * @return {void}
   */
  removePicture = (): void => {
    this.remove(this.pictureLayer);
    this.pictureLayer = {};
  }
}
